var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { CircularProgress, MenuItem, Paper, TextField, withStyles } from '@material-ui/core';
import TextInputCss from "./css/TextInputCss";
import Autosuggest from 'react-autosuggest';
import Highlighter from "react-highlight-words";
import { getLibelleFromValue, getSuggestions } from './actions/AutocompleteActions';
import CancelIcon from '@material-ui/icons/Cancel';

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      keyword: '',
      suggestions: [],
      loading: false,
      showClearIcon: false
      /**
       * Retourne le nouveau state en fonction des nextProps
       * @param  {[type]} nextProps [description]
       * @param  {[type]} prevState [description]
       * @return {[type]}           [description]
       */

    }, _this.handleChange = function (name) {
      return function (event, _ref) {
        var newValue = _ref.newValue;

        _this.setState({
          keyword: newValue
        });
      };
    }, _this.handleChange = function (name) {
      return function (event, _ref2) {
        var newValue = _ref2.newValue;
        var nameProps = _this.props.name,
            oldValue = _this.state[nameProps],
            lastValue = newValue.length > 0 ? oldValue : '';

        _this.setState({
          keyword: newValue
        }, function () {
          var _this$setState;

          _this.setState((_this$setState = {}, _this$setState[nameProps] = lastValue, _this$setState.showClearIcon = newValue.length > 0, _this$setState));

          if (oldValue && oldValue.length > 0 && newValue.length === 0) _this.props.onChangeHandler(_this.props.name, {
            target: {
              value: lastValue
            }
          });
        });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TextInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var newState = _extends({}, prevState);

    if (nextProps.name && nextProps.value !== prevState[nextProps.name]) {
      var _extends2;

      newState = _extends({}, newState, (_extends2 = {}, _extends2[nextProps.name] = nextProps.value, _extends2));
    }

    return newState;
  };

  TextInput.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        type = _props.type,
        name = _props.name;

    if (type && type === 'autocomplete' && this.state[name]) {
      getLibelleFromValue(this.state[name], this.props.autocompleteProps.collectionName, function (data) {
        if (data) _this2.setState({
          keyword: data.label
        });
      });
      this.setState({
        showClearIcon: this.state[name] && this.state[name].length > 0
      });
    }
  };
  /**
   * Retourne le champ de recherche de l'autocomplete
   * @param  {[type]} inputProps [description]
   * @return {[type]}            [description]
   */


  TextInput.prototype.renderInputComponent = function renderInputComponent(props) {
    var _this3 = this;

    var classes = props.classes,
        _props$inputRef = props.inputRef,
        _inputRef = _props$inputRef === undefined ? function () {} : _props$inputRef,
        ref = props.ref,
        other = _objectWithoutProperties(props, ['classes', 'inputRef', 'ref']);

    var _props2 = this.props,
        collectionStore = _props2.collectionStore,
        name = _props2.name;
    var inputProps = Object.keys(this.props).filter(function (k) {
      return !['name', 'collectionStore', 'onChangeHandler', 'value', 'autocompleteProps', 'type', 'classes', 'dispatch'].includes(k);
    }).reduce(function (obj, key) {
      obj[key] = _this3.props[key];
      return obj;
    }, {});
    return React.createElement(TextField, _extends({
      error: !!collectionStore.errors && !!collectionStore.errors[name],
      helperText: this.getErrorMessage(name),
      value: this.state[name] ? this.state[name] : '',
      InputProps: {
        inputRef: function inputRef(node) {
          ref(node);

          _inputRef(node);
        },
        classes: {
          input: (classes.input ? classes.input : '') + ' no-enter'
        }
      }
    }, inputProps, other));
  };
  /**
   * Retourne la valeur Suggérée
   * @param  {[type]} suggestion [description]
   * @return {[type]}            [description]
   */


  TextInput.prototype.getSuggestionValue = function getSuggestionValue(suggestion) {
    var name = this.props.name;
    this.props.onChangeHandler(name, {
      target: {
        value: suggestion.value,
        name: name
      }
    });
    return suggestion.label;
  };
  /**
   * Renvoie le container pour les suggestions
   * @param  {[type]} options [description]
   * @return {[type]}         [description]
   */


  TextInput.prototype.renderSuggestionsContainer = function renderSuggestionsContainer(options) {
    return React.createElement(Paper, _extends({}, options.containerProps, {
      style: {
        textAlign: this.state.loading ? 'center' : 'left'
      },
      square: true
    }), options.children);
  };
  /**
   * Retourne la liste des résultats
   * @param suggestion
   * @returns {*}
   */


  TextInput.prototype.renderSuggestion = function renderSuggestion(suggestion) {
    var loader = this.props.classes.loader;
    if (this.state.loading) return React.createElement(MenuItem, {
      component: 'div'
    }, React.createElement(CircularProgress, {
      className: loader,
      size: 28
    }));
    return React.createElement(MenuItem, {
      component: 'div'
    }, React.createElement(Highlighter, {
      highlightClassName: this.props.classes.autocompleteBold,
      searchWords: this.state.keyword.split(' '),
      autoEscape: true,
      textToHighlight: suggestion.label
    }));
  };
  /**
   * HAndler changement de keyword
   * @param name
   * @returns {Function}
   */

  /**
   * Remet à 0 les suggestions
   * @return {[type]} [description]
   */


  TextInput.prototype.handleSuggestionsClearRequested = function handleSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    });
  };
  /**
   * Point d'entrée pour aller intéroger l'api
   * @param  {[type]} value [description]
   * @return {[type]}       [description]
   */


  TextInput.prototype.handleSuggestionsFetchRequested = function handleSuggestionsFetchRequested(_ref3) {
    var _this4 = this;

    var value = _ref3.value;
    if (this.state.SuggestionTimeoutHandle) clearTimeout(this.state.SuggestionTimeoutHandle); // eslint-disable-next-line

    this.state.SuggestionTimeoutHandle = setTimeout(function () {
      var handle = setTimeout(function () {
        _this4.setState({
          loading: true,
          suggestions: ['loading']
        });
      }, 300);
      getSuggestions(value, _this4.props.autocompleteProps.collectionName, function (suggestions) {
        clearTimeout(handle);

        _this4.setState({
          suggestions: suggestions,
          loading: false
        });
      });
    }, 100);
  };
  /**
   * Retourne le message d'erreur pour le champ demandé
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */


  TextInput.prototype.getErrorMessage = function getErrorMessage(name) {
    var collectionStore = this.props.collectionStore;

    if (collectionStore.errors && collectionStore.errors[name]) {
      return collectionStore.errors[name].map(function (err, index) {
        return React.createElement('span', {
          style: {
            display: 'block'
          },
          key: index
        }, err);
      });
    } else return null;
  };
  /**
   * Handler du changement sur les inputs
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */


  TextInput.prototype.onChangeHandler = function onChangeHandler(name, event) {
    var _setState;

    this.setState((_setState = {}, _setState[name] = event.target.value, _setState));
    this.props.onChangeHandler(name, event);
  };
  /**
   * HAndler changement de keyword
   * @param  {[type]} e [description]
   * @return {[type]}   [description]
   */

  /**
   * Génère l'affichage du bouton de clearing Auto Suggest
   * @param classes
   * @returns {*}
   */


  TextInput.prototype.getClearAutoSuggestButton = function getClearAutoSuggestButton(classes) {
    if (this.state.showClearIcon) return React.createElement('div', {
      className: classes.autoSuggestClearButton,
      onClick: this.onClearAutoSuggest.bind(this)
    }, React.createElement(CancelIcon, {
      className: classes.clearIcon,
      color: "primary"
    }));
  };
  /**
   * Vide le champ d'autosuggestion et execute le callback transmis lors de l'appel au composant
   */


  TextInput.prototype.onClearAutoSuggest = function onClearAutoSuggest() {
    var _this5 = this;

    this.setState({
      keyword: '',
      showClearIcon: false
    }, function () {
      if (_this5.props.onClearHandler) _this5.props.onClearHandler();
    });
  };
  /**
   * Rendu Final
   * @return {[type]} [description]
   */


  TextInput.prototype.render = function render() {
    var _this6 = this;

    var _props3 = this.props,
        collectionStore = _props3.collectionStore,
        name = _props3.name,
        type = _props3.type,
        classes = _props3.classes,
        label = _props3.label,
        placeholder = _props3.placeholder;
    var inputProps = Object.keys(this.props).filter(function (k) {
      return !['name', 'collectionStore', 'onChangeHandler', 'value', 'classes', 'dispatch'].includes(k);
    }).reduce(function (obj, key) {
      obj[key] = _this6.props[key];
      return obj;
    }, {});

    if (type && type === 'autocomplete') {
      var autosuggestProps = {
        renderInputComponent: this.renderInputComponent.bind(this),
        suggestions: this.state.suggestions,
        onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested.bind(this),
        onSuggestionsClearRequested: this.handleSuggestionsClearRequested.bind(this),
        getSuggestionValue: this.getSuggestionValue.bind(this),
        renderSuggestion: this.renderSuggestion.bind(this)
      };
      return React.createElement('div', {
        className: classes.autoSuggestContainer
      }, React.createElement(Autosuggest, _extends({}, autosuggestProps, {
        inputProps: {
          label: label,
          classes: classes,
          placeholder: placeholder,
          value: this.state.keyword,
          onChange: this.handleChange()
        },
        theme: {
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        },
        renderSuggestionsContainer: this.renderSuggestionsContainer.bind(this)
      })), this.getClearAutoSuggestButton(classes));
    } else {
      return React.createElement(TextField, _extends({
        error: !!collectionStore.errors && !!collectionStore.errors[name],
        helperText: this.getErrorMessage(name),
        value: this.state[name] ? this.state[name] : '',
        onChange: this.onChangeHandler.bind(this, name)
      }, inputProps, {
        theme: {}
      }), this.props.children);
    }
  };

  return TextInput;
}(Component);

TextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  collectionStore: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  onChangeHandler: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string
} : {};
TextInput = connect(function (store) {
  return {};
})(TextInput);
export default withStyles(TextInputCss)(TextInput);